import {
  DashboardOutlined,
  LineChartOutlined,
  SettingOutlined,
  DesktopOutlined,
  AlertOutlined,
  ReconciliationOutlined,
} from "@ant-design/icons";
import { Flex, Badge, theme } from "antd";
import { useState, useEffect } from "react";
import useFetch from "../hooks/useFetch";

const header_height = 58;

export default function useNavMenu(siteSelected) {
  // load theme token
  const { token } = theme.useToken();

  const [fetchWrapper] = useFetch();

  // alarm count for badges
  const [warningAlarmCount, setWarningAlarmCount] = useState(0);
  const [dangerAlarmCount, setDangerAlarmCount] = useState(0);

  /* API to get alarm count */
  function getAlarmCount() {
    fetchWrapper({
      endpoint_url: "main_layout/getAlarmCount",
      body: {
        site_id: siteSelected,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          setWarningAlarmCount(fetch_output.warning_alarm);
          setDangerAlarmCount(fetch_output.danger_alarm);
        }
      },
    });
  }

  useEffect(() => {
    if (siteSelected) {
      getAlarmCount();
    }
  }, [siteSelected]);

  const NavMenu = [
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 4, height: header_height }}
        >
          <DashboardOutlined style={{ marginRight: 8 }} />
          Dashboard
        </Flex>
      ),
      key: "Dashboard",
    },
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 4, height: header_height }}
        >
          <DesktopOutlined style={{ marginRight: 8 }} />
          Device
        </Flex>
      ),
      key: "Device",
      children: [
        { label: "Monitoring", key: "Monitoring" },
        { label: "Single Line Diagram", key: "SingleLineDiagram" },
      ],
    },
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 4, height: header_height }}
        >
          <LineChartOutlined style={{ marginRight: 8 }} />
          Trending
        </Flex>
      ),
      key: "Trending",
      children: [
        { label: "Power Demand", key: "Power" },
        { label: "Energy Demand", key: "Energy" },
        { label: "Parameter", key: "Parameter" },
      ],
    },
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 4, height: header_height }}
        >
          <AlertOutlined style={{ marginRight: 8 }} />
          Alarm
          <Badge
            count={warningAlarmCount}
            dot={false}
            showZero={false}
            style={{ marginRight: 2, backgroundColor: token["orange-5"] }}
          />
          <Badge
            count={dangerAlarmCount}
            dot={false}
            showZero={false}
            style={{ backgroundColor: token.red5 }}
          />
        </Flex>
      ),
      key: "Alarm",
    },
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 4, height: header_height }}
        >
          <LineChartOutlined style={{ marginRight: 8 }} />
          Reports
        </Flex>
      ),
      key: "Reports",
      children: [
        { label: "Overview", key: "Overview" },
        { label: "Billing", key: "Billing" }
      ],
    },
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 4, height: header_height }}
        >
          <SettingOutlined style={{ marginRight: 8 }} />
          Configuration
        </Flex>
      ),
      key: "Configuration",
    },
  ];

  return [NavMenu, header_height];
}
